import { render, staticRenderFns } from "./under-maintenance-page.html?vue&type=template&id=137bd0e0&scoped=true&"
import script from "./under-maintenance-page.js?vue&type=script&lang=js&"
export * from "./under-maintenance-page.js?vue&type=script&lang=js&"
import style0 from "./under-maintenance-page.scss?vue&type=style&index=0&id=137bd0e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bd0e0",
  null
  
)

export default component.exports